import { createContext } from 'react';
import {
	ICheckoutPageSettings,
	ICheckoutPageSlots
} from '../../../../api/checkouts/types/checkout-page.type';

/**
 * Configurações da página customizada do checkout (builder do hub) para os
 * componentes do formulário. Vazio = comportamento padrão da plataforma.
 */
export const CheckoutPageContext = createContext<ICheckoutPageSettings>({});

/**
 * Widgets ancorados no botão de compra (acima/abaixo), vindos do builder.
 * Contexto separado das settings para não mexer no shape já consumido.
 */
export const CheckoutPageSlotsContext = createContext<ICheckoutPageSlots>({});

/**
 * O checkout tem página de confirmação montada no builder? Decide o destino
 * do redirect pós-compra (thanks própria × obrigado da plataforma).
 */
export const CheckoutPageConfirmationContext = createContext<boolean>(false);
